import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=06393e1d"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06393e1d')) {
      api.createRecord('06393e1d', component.options)
    } else {
      api.reload('06393e1d', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=06393e1d", function () {
      api.rerender('06393e1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/account/views/Main.vue"
export default component.exports